import Component from 'components/pages/Cashbacks/Cashbacks.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('cashbacks');
export default buildPage(Component, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Cashbacks',
    description:
      'Earn cashback on great products and enjoy your wallet being a little bigger at the end of the month.',
  },
});
